import { useEffect, useState } from 'react';
import { getNewsletterByNumero } from '../../project/services/NewsletterService';

// Versions linguistiques d'un même numéro : { [idlanguage]: id_newsletter }, une langue absente = version manquante.
export function useVersionsNewsletter(numero, languages) {
  const [versions, setVersions] = useState({});

  useEffect(() => {
    if (!numero || languages.length === 0) return;
    let isActif = true;
    Promise.all(languages.map((l) => getNewsletterByNumero(numero, l.idlanguage).catch(() => undefined)))
      .then((resultats) => {
        if (!isActif) return;
        const parLangue = {};
        resultats.forEach((n, i) => { if (n) parLangue[languages[i].idlanguage] = n.id_newsletter; });
        setVersions(parLangue);
      });
    return () => { isActif = false; };
  }, [numero, languages]);

  return versions;
}
